import generalSection from "../_section/section.class";
import {adminSeparationAgreementUpload, userSeparationAgreementUpload} from "./upload";
import DataForm from "./DataForm";

export class userSeparationAgreementSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userSeparationAgreementUpload);
        // Add missing date error

    }
}

export class adminSeparationAgreementSection extends userSeparationAgreementSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminSeparationAgreementUpload);
        this.DataForm = DataForm
        this.sortByDateProp('documentDate');
        this.activeUpload = this.uploads.find(u=> u.allValuesAnswered && u.isVerifiable)
        this.setProblems(this.problemsList.singleUploadUserProblems())
    }

    get documentDate() {
        if (this.activeUpload && this.activeUpload.values.documentDate) {
            return this.activeUpload.values.documentDate;
        }
        return null;
    }
    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags: [
                    {
                        name: 'Document Date',
                        value: this.documentDate ? this.documentDate.format('D MMM YYYY') : 'N/A'
                    }
                ]
            }
        ]
    }
}